import React, { useEffect, useState } from "react";
import { Input, Button, notification } from "antd";
import { EditTwoTone, CheckOutlined, CloseOutlined } from "@ant-design/icons";

const EditInputElement = ({
                              initialValue,
                              onSave,
                              placeholder = "",
                              inputType = "text",
                              validationPattern,
                              errorMessage = "Invalid input",
                              style = {},
                              isUnique,
                              isAuthor,
                              maxWidth,
                          }) => {
    const [isEditing, setIsEditing] = useState(false);
    const [value, setValue] = useState(initialValue);
    const [error, setError] = useState("");

    useEffect(() => {
        setValue(initialValue);
    }, [initialValue]);

    const handleEditClick = () => {
        setIsEditing(true);
        setError("");
    };

    const handleSave = () => {
        if (value === initialValue) {
            setIsEditing(false);
            setError("");
            return;
        }

        if (validationPattern && !new RegExp(validationPattern).test(value)) {
            setError(errorMessage);
            return;
        }
        if (isUnique && !isUnique(value)) {
            notification.error({
                message: "Error Saving",
                description: "Name already exists. Please use a different name.",
            });
            return;
        }
        onSave(value);
        setIsEditing(false);
    };

    const handleCancel = () => {
        setValue(initialValue);
        setIsEditing(false);
        setError("");
    };

    const inputStyle = {
        border: "none",
        outline: "none",
        boxShadow: "none",
        backgroundColor: "transparent",
        borderBottom: "1px solid transparent",
        margin: "0 5px",
        width: "auto",
        minWidth: "50px",
        padding: "0",
    };

    const focusedInputStyle = {
        ...inputStyle,
        borderBottom: "1px solid #1890ff",
        padding: "2px 8px",
        borderRadius: "4px",
        transition: "all 0.2s ease",
        fontWeight: 700,
    };

    const buttonStyle = {
        height: "24px",
        width: "24px",
        display: "flex",
        alignItems: "center",
        padding: "0 8px",
        marginLeft: "5px",
        borderRadius: "4px",
        justifyContent: "center",
        backgroundColor: "white",
        color: "black",
        border: "1px solid #2b2626",
    };

    const combinedStyle = { display: "flex", alignItems: "center", ...style };
    const textDisplayStyle = {
        maxWidth: maxWidth ?? "300px",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
            handleSave();
        } else if (e.key === "Escape") {
            handleCancel();
        }
    };

    return (
        <div >
            {!isEditing ? (
                <div style={combinedStyle}>
                    <span style={textDisplayStyle}>{value || placeholder}</span>
                    {isAuthor && (
                        <EditTwoTone
                            onMouseDown={(e) => e.stopPropagation()}
                            className="edit-icon"
                            style={{ marginLeft: "10px", cursor: "pointer" }}
                            onClick={handleEditClick}
                        />
                    )}
                </div>
            ) : (
                <div style={combinedStyle}>
                    <Input
                        autoFocus
                        type={inputType}
                        value={value}
                        onChange={(e) => setValue(e.target.value)}
                        onKeyDown={handleKeyDown}
                        style={focusedInputStyle}
                    />
                    <Button
                        onMouseDown={(e) => e.stopPropagation()}
                        type="primary"
                        icon={<CheckOutlined />}
                        onClick={handleSave}
                        style={buttonStyle}
                    />
                    <Button
                        onMouseDown={(e) => e.stopPropagation()}
                        icon={<CloseOutlined />}
                        onClick={handleCancel}
                        style={buttonStyle}
                    />
                    {error && (
                        <div style={{ color: "red", marginTop: "5px" }}>
                            {error}
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default EditInputElement;
